function CustomException(message, code = 'ue-01') {
  this.message = message;
  this.name = 'CustomException';
  this.code = code;
}

export default CustomException;
